import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="w-full bg-steel-950 px-6 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-82" data-mp="9ucr96qafl2n">
      <div className="mx-auto max-w-3xl text-center" data-id="element-83" data-mp="etft6iaz1b6e">
        <SectionHeading id="guarantee-title" badge="100% risk-free" badgeIcon={ShieldCheckIcon} title='The "First Day of Class" Guarantee' data-id="element-84" data-mp="ev0podguj46w" />

        <Reveal className="mt-8 border border-circuit-400/20 bg-steel-900 p-8" data-id="element-85" data-mp="nu48dgc3phkv">
          <p className="text-base leading-relaxed text-ink-200" data-id="element-86" data-mp="nrrjskbu88yu">
            Download the IIIS 2026. If you don't feel it will save you at least 100 hours of work this
            year, or if it doesn't meet your technical standards, just email us within 7 days. We refund
            every penny — no questions asked.
          </p>
          <p className="mt-6 inline-block border border-white/[0.09] px-4 py-2 font-display text-sm font-semibold uppercase tracking-[0.14em] text-ember-400" data-id="element-87" data-mp="17hljrlophue5">
            You keep the bonuses as a thank-you for trying it
          </p>
        </Reveal>
      </div>
    </section>;
}